import $ from "jquery";
import React from "react";

/**
 * Render the hidden form field required by Rails to prevent Cross-Site Request Forgery.
 *
 * @returns {object} The React element
 * @example
 *   <form action="/users" method="post">
 *     <CsrfToken />
 *   </form>
 */
function CsrfToken() {
  const csrfName = $("meta[name='csrf-param']").attr("content");
  const csrfValue = $("meta[name='csrf-token']").attr("content");

  return <input name={csrfName} type="hidden" value={csrfValue} />;
}

export default CsrfToken;
